import React from 'react'
import AboutUs from '../AboutUs/AboutUs'
import QuestionAndFreeConsultation from './QuestionAndFreeConsultation/QuestionAndFreeConsultation'
import Portfolio from '../Portfolio/Portfolio'
import WelcomePage from './WelcomePage/WelcomePage'
import HomeAboutUs from './HomeAboutUs/HomeAboutUs'
import UserFeedback from './UserFeedback/UserFeedback'
import WhatIDo from './WhatIDo/WhatIDo'
import Categories from './Categories/Categories'
import BPO from './BPO/BPO'
import ImageCarousal from './ImageCarousal/ImageCarousal'

const HomePage = () => {
  return (
    <>
    <WelcomePage/>
        {/* <HomeAboutUs/> */}
           <WhatIDo/>
     <Categories/>
     {/* <BPO/> */}
   
    <QuestionAndFreeConsultation/>
    <ImageCarousal/>
    <UserFeedback/>
 
 
    </>
  )
}

export default HomePage
